var _path, _path2, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFiveLongBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 0 30 L 40 30 L 50 40 L 100 40 L 130 50 L 170 50 L 170 150 L 130 150 L 100 160 L 100 160 L 50 160 L 40 170 L 0 170 Z",
    fill: "#aaa",
    stroke: "black",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 157.5 115 L 162 115 L 162 85 L 100 85 L 100 115 L 130 115 L 130 85",
    fill: "transparent",
    stroke: "black",
    strokeWidth: 6
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 135,
    x2: 15,
    y2: 135,
    stroke: "white",
    strokeWidth: 4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 135,
    x2: 30,
    y2: 135,
    stroke: "white",
    strokeWidth: 4
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 35,
    y1: 135,
    x2: 45,
    y2: 135,
    stroke: "white",
    strokeWidth: 4
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 135,
    x2: 60,
    y2: 135,
    stroke: "white",
    strokeWidth: 4
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 65,
    y1: 135,
    x2: 75,
    y2: 135,
    stroke: "white",
    strokeWidth: 4
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 135,
    x2: 90,
    y2: 135,
    stroke: "white",
    strokeWidth: 4
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 95,
    y1: 135,
    x2: 105,
    y2: 135,
    stroke: "white",
    strokeWidth: 4
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 110,
    y1: 135,
    x2: 120,
    y2: 135,
    stroke: "white",
    strokeWidth: 4
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 125,
    y1: 135,
    x2: 135,
    y2: 135,
    stroke: "white",
    strokeWidth: 4
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 135,
    x2: 150,
    y2: 135,
    stroke: "white",
    strokeWidth: 4
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 155,
    y1: 135,
    x2: 165,
    y2: 135,
    stroke: "white",
    strokeWidth: 4
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 65,
    x2: 15,
    y2: 65,
    stroke: "white",
    strokeWidth: 4
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 65,
    x2: 30,
    y2: 65,
    stroke: "white",
    strokeWidth: 4
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 35,
    y1: 65,
    x2: 45,
    y2: 65,
    stroke: "white",
    strokeWidth: 4
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 65,
    x2: 60,
    y2: 65,
    stroke: "white",
    strokeWidth: 4
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 65,
    y1: 65,
    x2: 75,
    y2: 65,
    stroke: "white",
    strokeWidth: 4
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 65,
    x2: 90,
    y2: 65,
    stroke: "white",
    strokeWidth: 4
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 95,
    y1: 65,
    x2: 105,
    y2: 65,
    stroke: "white",
    strokeWidth: 4
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 110,
    y1: 65,
    x2: 120,
    y2: 65,
    stroke: "white",
    strokeWidth: 4
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 125,
    y1: 65,
    x2: 135,
    y2: 65,
    stroke: "white",
    strokeWidth: 4
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 65,
    x2: 150,
    y2: 65,
    stroke: "white",
    strokeWidth: 4
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 155,
    y1: 65,
    x2: 165,
    y2: 65,
    stroke: "white",
    strokeWidth: 4
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 100,
    x2: 15,
    y2: 100,
    stroke: "white",
    strokeWidth: 4
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 100,
    x2: 30,
    y2: 100,
    stroke: "white",
    strokeWidth: 4
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    x1: 35,
    y1: 100,
    x2: 45,
    y2: 100,
    stroke: "white",
    strokeWidth: 4
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 100,
    x2: 60,
    y2: 100,
    stroke: "white",
    strokeWidth: 4
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    x1: 65,
    y1: 100,
    x2: 75,
    y2: 100,
    stroke: "white",
    strokeWidth: 4
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 100,
    x2: 90,
    y2: 100,
    stroke: "white",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 145 50 L 145 45 C 145 39, 155 39, 155 45 L 155 50",
    fill: "#aaa",
    stroke: "black",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 145 150 L 145 155 C 145 161, 155 161, 155 155 L 155 150",
    fill: "#aaa",
    stroke: "black",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 70 40 L 70 35 C 70 29, 80 29, 80 35 L 80 40",
    fill: "#aaa",
    stroke: "black",
    strokeWidth: 3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 70 160 L 70 165 C 70 171, 80 171, 80 165 L 80 160",
    fill: "#aaa",
    stroke: "black",
    strokeWidth: 3
  })), "\n  Sorry, your browser does not support inline SVG.\n");
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiveLongBack);
export default __webpack_public_path__ + "static/media/FiveLongBack.8e7fa8ae99aff8a707f955e546b334fa.svg";
export { ForwardRef as ReactComponent };